export default {"src":"/_next/static/media/KG1.53c7965e.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};